import { render, staticRenderFns } from "./editPackage.vue?vue&type=template&id=fa919f5e"
import script from "./editPackage.vue?vue&type=script&lang=js"
export * from "./editPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports